import React from "react";
import { useDrop } from "react-dnd";
import { HERO_SLIDE_DND_TYPE } from "./hero-slide-preview";
import { ArrowLeftRight } from "lucide-react";

interface ISlideDropZoneProps {
  dropIndex: number; // Where to insert (between which slides)
  onDrop: (fromIndex: number, toIndex: number) => void;
}

export default function SlideDropZone ({ dropIndex, onDrop }: ISlideDropZoneProps) {
  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept: HERO_SLIDE_DND_TYPE,
    drop: (item: { index: number }) => {
      if (typeof item.index === "number") onDrop(item.index, dropIndex);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
  });

  // Visual: widen and fade in when active/drag-over
  return (
    <div
      ref={dropRef}
      className={`
        flex items-center justify-center
        transition-all duration-200
        ${isOver
          ? "bg-white/30 border-2 border-blue-400 w-[140px] h-[105px] shadow-lg backdrop-blur-sm"
          : "bg-transparent border-transparent w-2 h-[80px]"}
        rounded-md flex-shrink-0 pointer-events-auto
      `}
      style={{
        minWidth: isOver ? 140 : 8,
        minHeight: isOver ? 105 : 80,
        zIndex: isOver ? 40 : 10,
      }}
      aria-hidden="true"
    >
      {isOver && 
        <ArrowLeftRight
          size={36}
          className="transition-opacity duration-200"
          style={{ opacity: isOver ? 0.55 : 0, color: "#3b82f6" }} // Satori blue
        />
      }
      
    </div>
  );
}